<ng-container *ngIf="(content$ | async) as content">
  <router-outlet></router-outlet>
  <app-keep-alive [keepAliveUrl]="content.siteMap.keepAliveUrl"></app-keep-alive>
</ng-container>
